import { useEffect } from 'react';
import { applyFavicon, readBrandingVisual } from '../utils/brandingVisualConfig';

const BrandingHeadManager = () => {
  useEffect(() => {
    const syncBrandingVisual = () => {
      const brandingVisual = readBrandingVisual();
      applyFavicon(brandingVisual.favicon_url || '/favicon.ico');
    };

    syncBrandingVisual();
    window.addEventListener('storage', syncBrandingVisual);
    window.addEventListener('provi:branding-visual-updated', syncBrandingVisual);

    return () => {
      window.removeEventListener('storage', syncBrandingVisual);
      window.removeEventListener('provi:branding-visual-updated', syncBrandingVisual);
    };
  }, []);

  return null;
};

export default BrandingHeadManager;
